import { createSlice } from '@reduxjs/toolkit'

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
  },
  reducers: {
  },
})

export default sidebarSlice.reducer